module.exports = __webpack_public_path__ + "img/jianshe.4da752fe.png";